angular.module('impactx.list', []);